// Constants
export const PIXELS_PER_INCH = 96;
export const CM_PER_INCH = 2.54;
export const BLEED_INCHES = 0.125;
export const DEFAULT_CARD_PRESETS = {
  horizontal: { width: 1050, height: 600 },
  vertical: { width: 600, height: 1050 },
};

export const calculateSafeArea = (dimensions, margin = 20) => {
  return {
    top: margin,
    left: margin,
    right: margin,
    bottom: margin,
    width: dimensions.width - (margin * 2),
    height: dimensions.height - (margin * 2),
  };
};

export const getCardDimensions = (preset, dpi = 300) => {
  return {
    width: 1050,
    height: 600,
  };
};

export const calculateCanvasDimensions = (cardPreset) => {
  return {
    width: 1050,
    height: 600,
  };
};

export const getOrientationPresets = () => {
  return DEFAULT_CARD_PRESETS;
};

export const hasValidPrintDimensions = (printDimensions) => {
  if (!printDimensions) return false;
  return (
    printDimensions.print_length_inches > 0 &&
    printDimensions.print_width_inches > 0
  );
};

export const inchesToPixels = (inches, dpi = 300) => {
  return Math.round(inches * dpi);
};

export const inchesToCm = (inches) => {
  return inches * CM_PER_INCH;
};

export const formatDimensionDisplay = (inches) => {
  const cm = inchesToCm(inches);
  return `${inches.toFixed(2)}" (${cm.toFixed(1)}cm)`;
};

export const calculateBleedArea = (dimensions, bleed = 12) => {
  return {
    top: -bleed,
    left: -bleed,
    right: bleed,
    bottom: bleed,
  };
};

export const validateDimensions = (width, height) => {
  return width > 0 && height > 0;
};
